import { Injectable, inject } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { MyTenantComponentsRestApi } from '../../../infrastructure/api/my-tenant-components-rest.api';
import { GetMyTenantComponentsResult } from './get-my-tenant-components.result';

@Injectable({ providedIn: 'root' })
export class GetMyTenantComponentsUseCase {
  private readonly _api = inject(MyTenantComponentsRestApi);

  public execute(): Observable<GetMyTenantComponentsResult> {
    return this._api.getMyComponents().pipe(
      map((data) => ({ success: true, data })),
      catchError((error: { message?: string }) => of({ success: false, error: error.message })),
    );
  }
}
